export default "__VITE_ASSET__e0b7f6dd__"